import React from 'react'

const LoaderComponent = () => {
  return (
    <div className="loading"><div className="custom-loader"></div></div>
  )
}

export default LoaderComponent